module.exports = __webpack_public_path__ + "img/Mouse.28a3e4ba.svg";